/**
 * Whether the local database is being opened right now — kept apart from
 * database.ts so the update code can ask without pulling RxDB into its chunk.
 *
 * A reload in this window leaves a connection behind that the next start waits
 * on (see db/openStall.ts). The app's own reloads must therefore wait for the
 * open to settle; only the person may cut it short.
 */

let opening = false;
let waiting: (() => void)[] = [];

export function setDatabaseOpening(value: boolean): void {
    opening = value;
    if (value) {
        return;
    }
    const settled = waiting;
    waiting = [];
    for (const resolve of settled) {
        resolve();
    }
}

/** Resolves once no open is running — at once if none is. */
export function whenDatabaseSettled(): Promise<void> {
    if (!opening) {
        return Promise.resolve();
    }
    return new Promise((resolve) => {
        waiting.push(resolve);
    });
}
